import { IDialogAction, IDialogStates, DIALOG_ACTION_TYPE, IUplevelDepartment } from './dialogContext';
import update from 'immutability-helper';
import { IListItem } from '@umu/umu-types';
import { onAllowPermissionSwitch } from './utils'
const cleanObj = (obj: any) => {
    Object.keys(obj).forEach((e: any) => {
        delete obj[e];
    });
};

export function DialogReducer(state: IDialogStates, action: IDialogAction): IDialogStates {
    let newState = state;
    const selectedMap = state.selectedMap;
    const excludeMap = state.excludeMap;
    const dataList = state.dataList;
    const pageInfo = state.pageInfo;
    switch (action.type) {
        case DIALOG_ACTION_TYPE.SET_DEFAULT_SELECTED_LIST:
            const { defaultSelectedList, defaultExcludeList } = action.payload;
            cleanObj(selectedMap);
            cleanObj(excludeMap);
            defaultSelectedList.forEach((i: any) => {
                if (i) {
                    selectedMap[i] = {} as IListItem;
                }
            });
            defaultExcludeList.forEach((i: string) => {
                if (i) {
                    excludeMap[i] = i;
                }
            });
            // console.log('selectedMap', selectedMap);
            newState = update(state, {
                // $merge: initState,
                excludeMap: {
                    $set: excludeMap,
                },
            });
            return newState;
        case DIALOG_ACTION_TYPE.UPDATE_SELECTED_MAP:
            const { list: _list } = action.payload;
            let _selectedMap: { [key: string]: IListItem} = {};

            _list.forEach((item: IListItem)=>{
                _selectedMap[item.id] = item;
            });

            newState = update(state, {
                selectedMap: {
                    $set: selectedMap,
                },
            });

            return newState;
        case DIALOG_ACTION_TYPE.SET_DEFAULT_SELECTED_DATAINFO:
            const { info } = action.payload;
            selectedMap[info.id] = info;
            break;
        case DIALOG_ACTION_TYPE.CLEAN:
            cleanObj(selectedMap);
            if (dataList) {
                dataList.forEach((data: IListItem) => (data.isSelected = false));
            }
            newState = update(state, {
                // $merge: initState,
                selectedMap: {
                    $set: selectedMap,
                },
                dataList: {
                    $set: dataList,
                },
            });
            // console.log('DIALOG_ACTION_TYPE.CLEAN', selectedMap, newState);
            return newState;
        case DIALOG_ACTION_TYPE.SET_DATALIST:
            const { isMore, list, currDepartmentId, pInfo } = action.payload;
            const retList: IListItem[] = [];
            const pInfoTemp = {
                count: (pInfo && pInfo.count) || pageInfo.count,
                currentPage: (pInfo && pInfo.currentPage) || pageInfo.currentPage,
                totalPage: (pInfo && pInfo.totalPage) || pageInfo.totalPage,
                size: (pInfo && pInfo.size) || pageInfo.size,
            };
            list.forEach((data: IListItem) => {
                data.isSelected = data.isSelected || !!selectedMap[data.id];
                if (data.isSelected) {
                    // 校准一些缓存信息, 如初始化的时候只有id，没有其他信息
                    selectedMap[data.id] = data;
                }
                if (!excludeMap[data.id]) {
                    retList.push(data);
                }
            });
            newState = update(state, {
                dataList: {
                    $set: isMore ? dataList.concat(retList) : retList,
                },
                currDepartmentId: {
                    $set: currDepartmentId,
                },
                isSearchMode: {
                    $set: false,
                },
                pageInfo: {
                    $set: pInfoTemp,
                },
                ts: {
                    $set: Date.now(),
                },
            });
            return newState;
        case DIALOG_ACTION_TYPE.SET_ALL_LIST_CHECKED:
            const { isChecked } = action.payload;

            dataList.forEach((data) => {
                const isDisabledCheck = onAllowPermissionSwitch(data.oriData, state.hasAllPermissionRoles);
                data.isSelected = isDisabledCheck ? false : isChecked;
                isChecked && !isDisabledCheck ? (selectedMap[data.id] = data) : delete selectedMap[data.id];
            });
            newState = update(state, {
                dataList: {
                    $set: [...dataList],
                }
            });
            return newState;
        case DIALOG_ACTION_TYPE.SET_DATAITEM:
            const { item, isAdd, isRadio } = action.payload;
            if (isRadio) {
                Object.keys(selectedMap).forEach((key) => delete selectedMap[key]);
            }
            !!isAdd ? (selectedMap[item.id] = item) : delete selectedMap[item.id];
            dataList.forEach((data) => {
                if (data.id === item.id) {
                    data.isSelected = !!isAdd;
                } else {
                    if (isRadio) {
                        data.isSelected = false;
                        if (selectedMap[data.id]) {
                            delete selectedMap[data.id];
                        }
                    }
                    data.isSelected = data.isSelected || !!selectedMap[data.id];
                }
            });
            newState = update(state, {
                dataList: {
                    $set: [...dataList],
                },
                selectedMap: {
                    $set: selectedMap,
                },
                ts: {
                    $set: Date.now(),
                },
            });
            // console.log('DialogReducer SET_DATAITEM', isRadio, state, newState);
            return newState;
        case DIALOG_ACTION_TYPE.SET_DATASUG:
            const sug = action.payload.list;
            sug.forEach((data: any) => (data.isSelected = data.isSelected || !!selectedMap[data.id]));
            newState = update(state, {
                dataList: {
                    $set: sug,
                },
                isSearchMode: {
                    $set: action.payload.isSearchMode,
                },
                ts: {
                    $set: Date.now(),
                },
            });
            // console.log('DialogReducer SET_DATASUG', isRadio, state, newState);
            return newState;
        case DIALOG_ACTION_TYPE.SET_CACHE:
            const enterpriseName = action.payload.enterpriseName || state.enterpriseName;
            const departmentCache = action.payload.departmentCache || state.departmentCache;
            newState = update(state, {
                departmentCache: {
                    $set: departmentCache,
                },
                enterpriseName: {
                    $set: enterpriseName,
                },
            });
            // console.log('DialogReducer SET_CACHE', state, newState);
            return newState;
        case DIALOG_ACTION_TYPE.SET_UPLEVEL_DEPARTMENT:
            const uplevelDepartmentList = action.payload.uplevelDepartmentList || [];
            const uplevelIdMap = action.payload.uplevelIdMap || {};
            const uplevelDepartment: IUplevelDepartment = {};
            uplevelDepartmentList.forEach((i: IListItem) => {
                if (!uplevelDepartment[i.id]) {
                    uplevelDepartment[i.id] = i;
                }
            });
            // console.log('uplevelDepartment', uplevelDepartment, uplevelIdMap);
            newState = update(state, {
                uplevelDepartment: {
                    $set: uplevelDepartment,
                },
                uplevelIdMap: {
                    $set: uplevelIdMap,
                },
            });
            return newState;
        default:
            newState = state;
    }
    return newState;
}
